<div class="mat-headline-5">{{ modalTitle | async }}</div>
<onsip-spacer></onsip-spacer>
<mat-spinner strokeWidth="16" diameter="110"></mat-spinner>
<onsip-spacer></onsip-spacer>
